/**
 * SDK transaction helpers
 *
 * Bridges `@takeover/sdk/contracts` calldata builders (which return
 * `{ to, abi, functionName, args }`) into the EIP-1193-style
 * `{ to, data, value }` shape consumed by `useTransactionQueue`.
 */

import { encodeFunctionData, type Abi, type Hex } from 'viem';
import type { AbiCall, TransactionCall } from '@takeover/sdk/contracts';

/**
 * Encode an SDK `AbiCall` into a ready-to-send `TransactionCall`.
 * Optionally attach a `value` (e.g. for native-token calls).
 */
export function abiCallToTx(call: AbiCall, value?: bigint): TransactionCall {
  return {
    to: call.to as Hex,
    data: encodeFunctionData({
      abi: call.abi as unknown as Abi,
      functionName: call.functionName,
      args: call.args,
    }),
    ...(value !== undefined ? { value } : {}),
  };
}
